// First-open guided-highlight steps per screen. Each step points at a real
// element by its data-testid; missing targets are skipped automatically.
export const COACHMARKS = {
  "teacher-home": [
    { target: "add-student-button", title: "Add a student", body: "Create a login for each child here — they sign in with a username and password." },
    { target: "nav-library", title: "Turn on lessons", body: "Open your Library to choose which subjects and lessons your students can see." },
    { target: "nav-lessons", title: "Make a lesson", body: "Use AI Lessons to generate a custom lesson, then assign it to your students." },
    { target: "nav-help", title: "Need a hand?", body: "The Help page has a step-by-step guide for your role anytime." },
  ],
  "school-home": [
    { target: "create-school-btn", title: "Name your school", body: "Give your school a name your teachers and families will see." },
    { target: "school-seat-meter", title: "Your teacher seats", body: "Each seat is one teacher license. Track how many are used here." },
    { target: "invite-email-input", title: "Invite a teacher", body: "Enter an email to send an invite, or leave blank for a shareable link." },
    { target: "send-invite-btn", title: "Send the invite", body: "An invite uses one seat until accepted — revoke a pending one to reclaim it." },
  ],
  "district-home": [
    { target: "create-district-btn", title: "Name your district", body: "Start by naming your district — every school lives under it." },
    { target: "new-school-name", title: "Add a school", body: "Create a school and give it a teacher-seat quota from your district pool." },
    { target: "add-school-btn", title: "Save the school", body: "The seats you allocate across schools can't exceed your total pool." },
  ],
  "reseller-home": [
    { target: "rb-name", title: "Name your brand", body: "This name and logo appear on your branded landing page." },
    { target: "rb-save", title: "Save your brand", body: "Save to unlock your shareable branded link." },
    { target: "rb-generate", title: "Generate codes", body: "Create redemption codes to gift free full access — one code per seat." },
    { target: "seat-meter", title: "Track your seats", body: "See how many seats you've issued and how many are still available." },
  ],
};
